import React from "react";
import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { SimpleCard } from "../../componentes/Common/SimpleCard";

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();

  const isAuthenticated = accounts.length > 0;

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        {isAuthenticated ? (
          <>
            <Typography variant="h4" component="h1">
              No tienes permisos
            </Typography>
            <Typography variant="body1">
              No tienes permisos para acceder a esta sección.
            </Typography>
            <Typography variant="body1">
              Por favor, contacta al analista de investigación para solicitar
              acceso.
            </Typography>
            <SimpleCard
              nombre="Adriana Katherine Vargas Rea"
              cargo="Analista de investigación"
              email="akvargas@espol.edu.ec"
            />
          </>
        ) : (
          <>
            <Typography variant="h4" component="h1">
              Usuario no autenticado
            </Typography>
            <Typography variant="body1">
              Debes iniciar sesión para poder acceder al sistema.
            </Typography>
          </>
        )}
        <br />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/inicio")}
        >
          VOLVER
        </Button>
      </div>
    </Container>
  );
};
